<template>
  <nav class="event-breadcrumb" aria-label="Breadcrumb">
    <template v-for="(item, index) in items" :key="`${item.label}-${index}`">
      <button
        v-if="item.to && index !== items.length - 1"
        type="button"
        class="event-breadcrumb__item"
        @click="$router.push(item.to)"
      >
        {{ item.label }}
      </button>

      <span
        v-else
        class="event-breadcrumb__item"
        :class="{ 'event-breadcrumb__item--active': index === items.length - 1 }"
      >
        {{ item.label }}
      </span>

      <span v-if="index !== items.length - 1" class="event-breadcrumb__separator">
        ›
      </span>
    </template>
  </nav>
</template>

<script>
export default {
  name: 'EventBreadcrumb',
  props: {
    items: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style scoped>
.event-breadcrumb {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;
  color: #6f7787;
  font-size: 13px;
}

.event-breadcrumb__item {
  padding: 0;
  border: 0;
  background: transparent;
  color: inherit;
  font: inherit;
}

button.event-breadcrumb__item {
  cursor: pointer;
}

.event-breadcrumb__item--active {
  color: #152752;
  font-weight: 700;
}

.event-breadcrumb__separator {
  color: #b6bdca;
}
</style>
